export var UserRole;
(function (UserRole) {
    UserRole["STUDENT"] = "student";
    UserRole["ADMIN"] = "admin";
    UserRole["SUPER_ADMIN"] = "super_admin";
    UserRole["MODERATOR"] = "moderator";
})(UserRole || (UserRole = {}));
export var SubscriptionTier;
(function (SubscriptionTier) {
    SubscriptionTier["FREE"] = "free";
    SubscriptionTier["PRO_MEDIUM"] = "pro_medium";
    SubscriptionTier["PRO_LIVE"] = "pro_live";
})(SubscriptionTier || (SubscriptionTier = {}));
export var SubscriptionPlatform;
(function (SubscriptionPlatform) {
    SubscriptionPlatform["IOS"] = "ios";
    SubscriptionPlatform["ANDROID"] = "android";
    SubscriptionPlatform["NEPAL_MANUAL"] = "nepal_manual";
    SubscriptionPlatform["NONE"] = "none";
})(SubscriptionPlatform || (SubscriptionPlatform = {}));
export var QuestionType;
(function (QuestionType) {
    QuestionType["UBT"] = "ubt";
    QuestionType["QUIZ"] = "quiz";
    QuestionType["CBT"] = "cbt";
})(QuestionType || (QuestionType = {}));
export var QuestionCategory;
(function (QuestionCategory) {
    QuestionCategory["READING"] = "reading";
    QuestionCategory["LISTENING"] = "listening";
})(QuestionCategory || (QuestionCategory = {}));
// EPS-TOPIK question types — 4 reading + 4 listening per official spec
export var QuestionSubcategory;
(function (QuestionSubcategory) {
    // Reading section
    QuestionSubcategory["VOCAB_GRAMMAR"] = "vocab_grammar";
    QuestionSubcategory["VISUAL"] = "visual";
    QuestionSubcategory["COMPREHENSION"] = "comprehension";
    QuestionSubcategory["CONTEXT_CLUES"] = "context_clues";
    // Listening section
    QuestionSubcategory["PICTURE"] = "picture";
    QuestionSubcategory["DIALOGUE"] = "dialogue";
    QuestionSubcategory["RESPONSE"] = "response";
    QuestionSubcategory["EXTENDED"] = "extended";
    // Supplementary (not part of the graded 4+4 EPS-TOPIK spec above) — powers
    // the mobile Practice tab's "Korean Culture" node: short reading passages
    // about Korean workplace/daily-life customs, not exam-format content.
    QuestionSubcategory["CULTURE"] = "culture";
})(QuestionSubcategory || (QuestionSubcategory = {}));
export const READING_SUBCATEGORIES = [
    QuestionSubcategory.VOCAB_GRAMMAR,
    QuestionSubcategory.VISUAL,
    QuestionSubcategory.COMPREHENSION,
    QuestionSubcategory.CONTEXT_CLUES,
];
export const LISTENING_SUBCATEGORIES = [
    QuestionSubcategory.PICTURE,
    QuestionSubcategory.DIALOGUE,
    QuestionSubcategory.RESPONSE,
    QuestionSubcategory.EXTENDED,
];
// EPS-TOPIK official test structure
export const EPS_TOPIK = {
    READING_COUNT: 20,
    LISTENING_COUNT: 20,
    TOTAL_QUESTIONS: 40,
    READING_MINUTES: 35,
    LISTENING_MINUTES: 35,
    TOTAL_MINUTES: 70,
    OPTIONS_PER_QUESTION: 4,
};
export var QuestionDifficulty;
(function (QuestionDifficulty) {
    QuestionDifficulty["BEGINNER"] = "beginner";
    QuestionDifficulty["INTERMEDIATE"] = "intermediate";
    QuestionDifficulty["ADVANCED"] = "advanced";
})(QuestionDifficulty || (QuestionDifficulty = {}));
export var QuestionLengthType;
(function (QuestionLengthType) {
    QuestionLengthType["SHORT"] = "short";
    QuestionLengthType["LONG"] = "long";
})(QuestionLengthType || (QuestionLengthType = {}));
export var QuestionFormat;
(function (QuestionFormat) {
    QuestionFormat["TEXT"] = "text";
    QuestionFormat["IMAGE"] = "image";
    QuestionFormat["AUDIO"] = "audio";
})(QuestionFormat || (QuestionFormat = {}));
export var QuestionTypePreset;
(function (QuestionTypePreset) {
    QuestionTypePreset["AUDIO_PICTURE_AUDIO"] = "audio_picture_audio";
    QuestionTypePreset["AUDIO_AUDIO"] = "audio_audio";
    QuestionTypePreset["AUDIO_IMAGE"] = "audio_image";
    QuestionTypePreset["AUDIO_TEXT"] = "audio_text";
    QuestionTypePreset["FILL_BLANK_TEXT"] = "fill_blank_text";
    QuestionTypePreset["PARAGRAPH_TEXT"] = "paragraph_text";
    QuestionTypePreset["PICTURE_TEXT"] = "picture_text";
    QuestionTypePreset["WORD_IMAGE"] = "word_image";
})(QuestionTypePreset || (QuestionTypePreset = {}));
export var UbtQuestionLayout;
(function (UbtQuestionLayout) {
    UbtQuestionLayout["SET_WITH_STEM"] = "set_with_stem";
    UbtQuestionLayout["NUMBERED_STEM"] = "numbered_stem";
    UbtQuestionLayout["NUMBER_ONLY"] = "number_only";
})(UbtQuestionLayout || (UbtQuestionLayout = {}));
export var PublishStatus;
(function (PublishStatus) {
    PublishStatus["DRAFT"] = "draft";
    PublishStatus["REVIEW"] = "review";
    PublishStatus["PUBLISHED"] = "published";
    PublishStatus["ARCHIVED"] = "archived";
})(PublishStatus || (PublishStatus = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "pending";
    PaymentStatus["UNDER_REVIEW"] = "under_review";
    PaymentStatus["APPROVED"] = "approved";
    PaymentStatus["REJECTED"] = "rejected";
})(PaymentStatus || (PaymentStatus = {}));
/** What a PaymentRequest is for — a subscription plan upgrade, or a one-off book purchase. */
export var PaymentItemType;
(function (PaymentItemType) {
    PaymentItemType["SUBSCRIPTION"] = "subscription";
    PaymentItemType["BOOK"] = "book";
})(PaymentItemType || (PaymentItemType = {}));
export var MockTestType;
(function (MockTestType) {
    MockTestType["UBT"] = "ubt";
    MockTestType["QUIZ"] = "quiz";
    MockTestType["CBT"] = "cbt";
    MockTestType["LIVE"] = "live";
})(MockTestType || (MockTestType = {}));
export var ExamAttemptType;
(function (ExamAttemptType) {
    ExamAttemptType["UBT"] = "ubt";
    ExamAttemptType["QUIZ"] = "quiz";
    ExamAttemptType["CBT"] = "cbt";
    ExamAttemptType["LIVE"] = "live";
})(ExamAttemptType || (ExamAttemptType = {}));
export var LeaderboardPeriod;
(function (LeaderboardPeriod) {
    LeaderboardPeriod["DAILY"] = "daily";
    LeaderboardPeriod["WEEKLY"] = "weekly";
    LeaderboardPeriod["MONTHLY"] = "monthly";
    LeaderboardPeriod["ALL_TIME"] = "alltime";
})(LeaderboardPeriod || (LeaderboardPeriod = {}));
export var NotificationType;
(function (NotificationType) {
    NotificationType["PAYMENT_APPROVED"] = "payment_approved";
    NotificationType["PAYMENT_REJECTED"] = "payment_rejected";
    NotificationType["LIVE_EXAM_REMINDER"] = "live_exam_reminder";
    NotificationType["STREAK_AT_RISK"] = "streak_at_risk";
    NotificationType["NEW_MOCK_TEST"] = "new_mock_test";
    NotificationType["RANK_CHANGE"] = "rank_change";
    NotificationType["DAILY_REMINDER"] = "daily_reminder";
    NotificationType["SYSTEM"] = "system";
    NotificationType["WEEKLY_REPORT"] = "weekly_report";
})(NotificationType || (NotificationType = {}));
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "active";
    SubscriptionStatus["EXPIRED"] = "expired";
    SubscriptionStatus["NONE"] = "none";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export var AuditAction;
(function (AuditAction) {
    AuditAction["CREATE"] = "create";
    AuditAction["UPDATE"] = "update";
    AuditAction["DELETE"] = "delete";
    AuditAction["APPROVE"] = "approve";
    AuditAction["REJECT"] = "reject";
    AuditAction["BAN"] = "ban";
    AuditAction["UNBAN"] = "unban";
    AuditAction["LOGIN"] = "login";
    AuditAction["LOGOUT"] = "logout";
    AuditAction["APPROVE_PAYMENT"] = "approve_payment";
    AuditAction["REJECT_PAYMENT"] = "reject_payment";
    AuditAction["UPDATE_SETTINGS"] = "update_settings";
    AuditAction["OVERRIDE_SUBSCRIPTION"] = "override_subscription";
    AuditAction["BULK_PUBLISH"] = "bulk_publish";
    AuditAction["BULK_ARCHIVE"] = "bulk_archive";
    AuditAction["OCR_EXTRACT"] = "ocr_extract";
    AuditAction["SCREENSHOT_ATTEMPT"] = "screenshot_attempt";
})(AuditAction || (AuditAction = {}));
//# sourceMappingURL=enums.js.map